document.addEventListener('DOMContentLoaded', function () {
    // Function to update the cart quantity
    function updateCartQuantity(line, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                line: line,
                quantity: quantity
            })
        })
            .then(response => response.json())
            .then(data => {
                // Reload the page to reflect the updated cart
                location.reload();
            })
            .catch(error => console.error('Error:', error));
    }

    // Add event listeners to the quantity buttons
    document.querySelectorAll('.cart-item-container > .item-quantity > .quantity-controls > .quantity-minus').forEach(button => {
        button.addEventListener('click', function () {
            const line = this.getAttribute('data-line');
            const input = document.querySelector(`input[data-line="${line}"]`);
            let quantity = parseInt(input.value);

            if (quantity > 1) {
                quantity -= 1;
                input.value = quantity;
                updateCartQuantity(line, quantity);
                updateCartBubble()
            }
        });
    });

    document.querySelectorAll('.cart-item-container > .item-quantity > .quantity-controls > .quantity-plus').forEach(button => {
        button.addEventListener('click', function () {
            const line = this.getAttribute('data-line');
            const input = document.querySelector(`input[data-line="${line}"]`);
            let quantity = parseInt(input.value);

            quantity += 1;
            input.value = quantity;
            updateCartQuantity(line, quantity);
            updateCartBubble()
        });
    });

    function updateCartBubble() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                var cartBubble = document.querySelector('.cart-bubble');
                if (data.item_count > 0) {
                    if (!cartBubble) {
                        cartBubble = document.createElement('div');
                        cartBubble.classList.add('cart-bubble');
                        document.querySelector('.cart-button').appendChild(cartBubble);
                    }
                    cartBubble.textContent = data.item_count;
                } else if (cartBubble) {
                    cartBubble.remove();
                }
            });
    }

    // Handle manual input changes
    document.querySelectorAll('.cart-item-container .item-quantity .quantity-selector').forEach(input => {
        input.addEventListener('change', function () {
            const line = this.getAttribute('data-line');
            let quantity = parseInt(this.value);

            if (quantity > 0) {
                updateCartQuantity(line, quantity);
                this.setAttribute('data-line', line);
                this.value = quantity;
                updateCartBubble()
            } else {
                this.value = 1;
            }
        });
    });

    document.querySelectorAll('.accessories-container .quantity-controls').forEach(function (quantityControl) {
        var minusButton = quantityControl.querySelector('.quantity-minus');
        var plusButton = quantityControl.querySelector('.quantity-plus');
        var quantityInput = quantityControl.querySelector('.quantity-selector');
        var quantityFormInput = quantityControl.parentElement.parentElement.querySelector('.quantity-input');

        minusButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (quantityInput.value > 1) {
                quantityInput.value--;
                quantityFormInput.value = quantityInput.value;
            }
        });

        plusButton.addEventListener('click', function (event) {
            event.preventDefault();
            quantityInput.value++;
            quantityFormInput.value = quantityInput.value;
        });

        quantityInput.addEventListener('change', function () {
            if (quantityInput.value > 0) {
                quantityFormInput.value = quantityInput.value;
            } else {
                quantityInput.value = 1;
                quantityFormInput.value = 1;
            }
        });

        quantityControl.dataset.eventsAdded = 'true';
    });
});
